import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../pipes/pipes.module';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { BasicTableComponent } from './basic-table/basic-table.component';
import { BLIconComponent } from './bl-icon/bl-icon.component';
import { FieldValidationComponent } from './field-validation/field-validation.component';
import { LinearProgressBarComponent } from './linear-progress-bar/linear-progress-bar.component';
import { LoaderComponent } from './loader/loader.component';
import { LocalLoaderComponent } from './local-loader/local-loader.component';
import { MultiselectComponent } from './multiselect/multiselect.component';
import { NotificationComponent } from './notification/notification.component';
import { ScrollButtonComponent } from './scroll-button/scroll-button.component';
import { SelectComponent } from './select/select.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        PipesModule
    ],
    declarations: [
        LoaderComponent,
        LocalLoaderComponent,
        ScrollButtonComponent,
        FieldValidationComponent,
        BasicTableComponent,
        BLIconComponent,
        NotificationComponent,
        AutocompleteComponent,
        SelectComponent,
        LinearProgressBarComponent,
        MultiselectComponent
        // AriaInputComponent
    ],
    exports: [
        LoaderComponent,
        LocalLoaderComponent,
        ScrollButtonComponent,
        FieldValidationComponent,
        BasicTableComponent,
        BLIconComponent,
        NotificationComponent,
        AutocompleteComponent,
        SelectComponent,
        LinearProgressBarComponent,
        MultiselectComponent
        // AriaInputComponent
    ]
})
export class ToolsModule {
}
